import { createSlice } from '@reduxjs/toolkit'
import {
  fetchCoinFlipGameReport,
  fetchCrashGameReport,
  fetchCrossGameReport,
  fetchDiceGameReport,
  fetchGongaMineGameReport,
  fetchHiloGameReport,
  fetchKenoGameReport,
  fetchPyramidPlinkoGameReport,
  fetchTowerGameReport
} from 'redux-thunk/thunk/GameReports/gameReports'

const initialState = {
  crashGameReport: null,
  diceGameReport: null,
  kenoGameReport: null,
  hiloGameReport: null,
  coinFlipGameReport: null,
  pyramidPlinkoGameReport: null,
  gongaMineGameReport: null,
  towerGameReport: null,
  crossGameReport: null
}

const gameReportsSlice = createSlice({
  name: 'gameReportsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          crashGameReport: action.payload
        }
      })
      .addCase(fetchDiceGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          diceGameReport: action.payload
        }
      })
      .addCase(fetchKenoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          kenoGameReport: action.payload
        }
      })
      .addCase(fetchHiloGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          hiloGameReport: action.payload
        }
      })
      .addCase(fetchCoinFlipGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          coinFlipGameReport: action.payload
        }
      })
      .addCase(fetchPyramidPlinkoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          pyramidPlinkoGameReport: action.payload
        }
      })
      .addCase(fetchGongaMineGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          gongaMineGameReport: action.payload
        }
      })
      .addCase(fetchTowerGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          towerGameReport: action.payload
        }
      })
      .addCase(fetchCrossGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          crossGameReport: action.payload
        }
      })
  }
})

export default gameReportsSlice.reducer
